import { HashRouter as Router, Redirect, Route } from "react-router-dom";
import TabConfig from "../TabConfig";
import AdminPage from "../AdminPage/AdminPage";
import EmployeePage from "../EmployeePage/EmployeePage";
import { UserContextProvider } from "./UserContext";
import UserContext from "./UserContext";
import ManageEmployees from "../AdminPage/Subpages/ManageEmployees";
import ManageAssigments from "../AdminPage/Subpages/ManageAssigments";
import ManageRaports from "../AdminPage/Subpages/ManageRaports";
import AssignmentDetails from "../AdminPage/Subpages/AssignmentDetails";
import CollectedTimeHistory from "../Shared/CollectedTimeHistory";
import AppInstruction from "../Shared/AppInstruction";
import LeavingsHistory from "../Shared/LeavingsHistory";
import HoursChecker from "../Shared/HoursChecker";
import WorktimeOverview from "../Shared/WokrtimeOverview/WorktimeOverview";
import DesktopWorktimeLayout from "../Shared/DesktopWorktimeAndActivityLayout/DesktopWorktimeLayout";
import MobileInAndOutPage from "../../components/Pages/MobileInAndOutPage";
import MobilityActivityStatusPage from "../../components/Pages/MobileActivityStatusPage";
import WorktimeHistory from "../AdminPage/Subpages/WorktimeHistory";
import WorktimeHistoryWithinDay from "../AdminPage/Subpages/WorktimeHistoryWithinDay";
import PreferencesLayout from "../Shared/Preferences/PreferencesLayout";
import ResourceAllocation from "../AdminPage/Subpages/ResourceAllocation";
import ResourceAllocationEmployeeDetail from "../AdminPage/Subpages/ResourceAllocationEmployeeDetail";
import { userRoleEnum } from "../../utils/enums";


export default function AppRouter() {
  return (
    <>
      <UserContextProvider>
        <UserContext.Consumer>
          {({ userData }) => (
            <>
              <Router>
                <Route exact path="/">
                  {userData.data.baseRole === userRoleEnum.Admin ? (
                    <Redirect to="/admin" />
                  ) : userData.data.baseRole === userRoleEnum.Manager ? (
                    <Redirect to="/resource-allocation" />
                  ) : (
                    <Redirect to="/worktime" />
                  )}
                </Route>
                <Route path="/admin">
                  {userData.data.baseRole === "Admin" ? (
                    <Route exact path="/admin">
                      <AdminPage />
                    </Route>
                  ) : (
                    <Redirect to="/" />
                  )}
                </Route>
                {userData.data.organization !== null ? (
                  <>
                    <Route
                      path="/admin/manage-assigments"
                      component={ManageAssigments}
                    />
                    <Route
                      path="/assignment-details/:id/:number"
                      component={AssignmentDetails}
                    />
                    <Route
                      path="/admin/manage-employees"
                      component={ManageEmployees}
                    />
                    <Route path="/admin/raports" component={ManageRaports} />
                    <Route
                      exact
                      path="/admin/registered-time-history"
                      component={WorktimeHistory}
                    />
                    <Route
                      path="/admin/registered-time-history/:id/details"
                      component={WorktimeHistoryWithinDay}
                    />
                    <Route
                      path="/collected-time-history"
                      component={CollectedTimeHistory}
                    />
                    <Route
                      path="/leavings-history"
                      component={LeavingsHistory}
                    />
                    <Route
                      path="/hours-checker"
                      render={() =>
                        userData.data.baseRole === "Admin" ? (
                          <HoursChecker />
                        ) : (
                          <Redirect to="/" />
                        )
                      }
                    />
                    <Route
                      path="/resource-allocation/:employeeId"
                      render={() =>
                        userData.data.baseRole === userRoleEnum.Admin ||
                        userData.data.baseRole === userRoleEnum.Manager ? (
                          <ResourceAllocationEmployeeDetail />
                        ) : (
                          <Redirect to="/" />
                        )
                      }
                    />
                    <Route
                      exact
                      path="/resource-allocation"
                      render={() =>
                        userData.data.baseRole === userRoleEnum.Admin ||
                        userData.data.baseRole === userRoleEnum.Manager ? (
                          <ResourceAllocation />
                        ) : (
                          <Redirect to="/" />
                        )
                      }
                    />
                  </>
                ) : null}
                <Route exact path="/employee" component={EmployeePage} />
                <Route exact path="/worktime" component={WorktimeOverview} />
                <Route exact path="/inAndOut" component={MobileInAndOutPage} />
                <Route 
                  exact 
                  path="/preferences"
                  component={PreferencesLayout}  
                ></Route>
                <Route
                  exact
                  path="/activityStatus"
                  component={MobilityActivityStatusPage}
                />
                <Route
                  exact
                  path="/desktopWorktime"
                  component={DesktopWorktimeLayout}
                />
                <Route exact path="/config" component={TabConfig} />
                <Route exact path="/quick-start" component={AppInstruction} />
              </Router>
            </>
          )}
        </UserContext.Consumer>
      </UserContextProvider>
    </>
  );
}
